<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <h3>{{ $t('marketing', 'orderDetail') }}</h3>
      </div>
      <el-row>
        <el-col :xl="24" style="margin-bottom: 20px">
          <h4>{{ $t('marketing', 'groupBuyInfo') }}</h4>
        </el-col>
        <el-col
          v-for="item in baseInfoConfig"
          class="pt5 pb5"
          :key="item.key"
          :xl="item.className ? 24 : 12"
        >
          <span class="field-name" style="flex-basis: auto">{{
            item.label
          }}</span>
          <span class="field-value">{{
            item.render ? item.render(info) : info[item.key]
          }}</span>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never" style="border-top: none">
      <div slot="header" class="clearfix">
        <h3>{{ $t('marketing', 'productInfo') }}</h3>
        <div class="item mt10" v-for="item in consigneeConfig" :key="item.key">
          <span class="field-name">{{ item.label }}</span>
          <span class="field-value">{{
            item.render ? item.render(info) : info[item.key]
          }}</span>
        </div>
      </div>
      <div>{{ $t('marketing', 'participantInfo') }}</div>
      <commonTable
        :tableData="info.ordersModelList"
        :loading="loading"
        @handleSizeChange="handleSizeChange"
        :currentPage="currentPage"
        :total="total"
      >
        <template v-slot:table>
          <el-table-column
            prop="ordersNo"
            align="center"
            :label="$t('marketing', 'orderNumber')"
            width="200px"
            show-overflow-tooltip
          />
          <el-table-column
            prop="nickeName"
            align="center"
            :label="$t('marketing', 'userNickname')"
            show-overflow-tooltip
          />
          <el-table-column
            prop="payPrice"
            align="center"
            :label="$t('marketing', 'paymentAmount')"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ (scope.row.payPrice / 100).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            :label="$t('marketing', 'orderTime')"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ setGetDataTimeSec(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="assembleTime"
            align="center"
            :label="$t('marketing', 'groupBuyTime')"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ setGetDataTimeSec(scope.row.assembleTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderState"
            align="center"
            :label="$t('marketing', 'orderStatus')"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.orderState | isState(scope.row.orderState) }}
            </template>
          </el-table-column>
        </template>
      </commonTable>
    </el-card>
  </div>
</template>

<script>
import { getGoodsAssembleInfo } from "@/api/joinGroup";
import { getDataTimeSec } from "@/utils";
import commonTable from "@/components/common/commonTable";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  mixins: [i18nMixin],
  data() {
    return {
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      info: {
        goodSpecModelList: [],
      },
      baseInfoConfig: [
        {
          label: this.$t('marketing', 'groupBuyStatus') + "：",
          render(info) {
            const type = {
              1: this.$t('marketing', 'groupBuyInProgress'),
              2: this.$t('marketing', 'groupBuySuccess'),
              3: this.$t('marketing', 'groupBuyFailed'),
              4: this.$t('marketing', 'groupBuyRefunded'),
            };
            return type[info.state];
          },
        },
        { label: this.$t('marketing', 'groupBuyMaxOpenGroups') + "：", key: "openRegiment" },
        { label: this.$t('marketing', 'groupBuyLeader') + "：", key: "nickeName" },
        { label: this.$t('marketing', 'groupBuyMaxJoinGroups') + "：", key: "joinRegiment" },
        { label: this.$t('marketing', 'groupBuyMinMembers') + "：", key: "assembleNum" },
        { label: this.$t('marketing', 'groupBuyMaxPurchase') + "：", key: "maxPurchase" },
        {
          label: this.$t('marketing', 'groupBuyRemainingMembers') + "：",
          className: "col-lg-12",
          render(info) {
            return info.assembleNum - info.putAssemble || 0;
          },
        },

        {
          label: this.$t('marketing', 'groupBuyStartTime') + "：",
          render(info) {
            return getDataTimeSec(info.startTime);
          },
          className: "col-lg-12",
        },
        {
          label: this.$t('marketing', 'groupBuyEndTime') + "：",
          render(info) {
            return getDataTimeSec(info.endTime);
          },
          className: "col-lg-12",
        },
      ],
      consigneeConfig: [
        {
          label: this.$t('marketing', 'productName') + "：",
          render(info) {
            var specName = info?.goodSpecModelList[0]?.specName;
            return `${info.goodsName}${specName}`;
          },
        },
      ],
    };
  },
  components: {
    commonTable,
  },
  computed: {
    setGetDataTimeSec() {
      return (val) => getDataTimeSec(val);
    },
  },
  filters: {
    isState(val) {
      const type = {
        1: this.$t('marketing', 'pendingPayment'),
        2: this.$t('marketing', 'pendingShipment'),
        3: this.$t('marketing', 'pendingReceipt'),
        4: this.$t('marketing', 'completed'),
        5: this.$t('marketing', 'cancelled'),
        6: this.$t('marketing', 'refundSuccess'),
      };
      return type[val];
    },
  },
  created() {
    this.getGoodsAssembleInfo();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
    },
    async getGoodsAssembleInfo() {
      const { id } = this.$route.query;
      try {
        const result = await getGoodsAssembleInfo(
          { assembleId: id },
          { showLoading: true }
        );
        this.info = result.data;
        this.total = result.data.ordersModelList.length
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>